import { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";


const DataTableOperationsDetails=(listOperation)=>{

    console.log("listOperation", listOperation);
    const [transactions, setTransactions] = useState(listOperation.listOperation);
 
  
    // function refFormatter(cell, row) {
    //   console.log("row", row);
    //   if (row.facture !== null) {
    //     return <span>{row.facture.ref}</span>;
    //   } else if (row.purchaseOrder !== null) {
    //     return <span>{row.purchaseOrder.refPo}</span>;
    //   }
    // }
    function titleFormatter(cell,row) {
      console.log("titleFormatter",row)
        return <span>{row.operation.code}-{row.operation.name}</span>;
      
    }
    function uniteFormatter(cell,row) {
      return <span>{row.workstation.code}-{row.workstation.name}</span>;
    
  }
  
    const columns = [
      {
        dataField: "id",
        text: "Operation",
        align: "center",
        headerAlign: "center",
        formatter: titleFormatter,
  
       
      },
      {
        dataField: "setupTime",
        text: "setupTime  (s)",
        align: "center",
        headerAlign: "center",
        headerStyle: () => {
          return { width: "15%" };
        },
        
      },
      {
        dataField: "transferTime",
        text: "transferTime (s)",
        align: "center",
        headerAlign: "center",
        headerStyle: () => {
          return { width: "15%" };
        },
        
      },
      {
        dataField: "workstation.id",
        text: "Unité de travail",
        align: "center",
        headerAlign: "center",
        formatter: uniteFormatter,
  
        headerStyle: () => {
          return { width: "15%" };
        },
        
      }
      
    ];
    
  
    const importProduct = (row) => {
      return (
        <div>
      
        </div>
      );
    };
    const expandRow = {
      renderer: (row) => importProduct(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
    };
  
    // const handleInfoClose = (event, reason) => {
    //   if (reason === "clickaway") {
    //     return;
    //   }
    //   setOpenInfoAlert(false);
    // };
  
    function handleTableChange({ products }) {
      return products;
    }
    const pageButtonRenderer = ({
      page,
      active,
      disable,
      title,
      onPageChange,
    }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      const activeStyle = {};
      if (active) {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      } else {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      if (typeof page === "string") {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      return (
        <li className="page-item">
          <button
            className="btn btn-dark"
            onClick={handleClick}
            style={activeStyle}
          >
            {page}
          </button>
        </li>
      );
    };
    const options = {
      pageButtonRenderer,
    };
  
    return (
          <ToolkitProvider
            keyField="id"
            data={transactions}
            columns={columns}
          >
            {(props) => (
              <div>
             
                <div className="row">
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    striped
                    hover
                    condensed
                    expandRow={expandRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
     
    );

}
export default DataTableOperationsDetails;